// reducers/CoursesReducer.js
const initialState = {
  courses: [],
};

const CoursesReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_COURSES":
      return {
        ...state,
        courses: action.payload,
      };
    default:
      return state;
  }
};

export default CoursesReducer;
